var exports = {
  "twitch": "LiveStreamBadge.module__twitch___U04wTW",
  "kick": "LiveStreamBadge.module__kick___U04wTW",
  "row": "LiveStreamBadge.module__row___U04wTW",
  "pill": "LiveStreamBadge.module__pill___U04wTW",
  "profile": "LiveStreamBadge.module__profile___U04wTW",
  "label": "LiveStreamBadge.module__label___U04wTW",
  "arrow": "LiveStreamBadge.module__arrow___U04wTW",
};

__webpack_require__.r(module.exports = exports);
